import styled from '@emotion/styled';
import { useIsDesktop } from '../hooks/useIsDesktop';

const BannerWrapper = styled.div`
  background-color: #fef3c7; /* yellow-100 */
  border-left: 4px solid #facc15; /* yellow-400 */
  color: #92400e; /* yellow-700 */
  padding: 12px;
  width: 100%;
`;

const BannerText = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;

export default function DesktopBanner() {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return null;
  }

  return (
    <BannerWrapper>
      <BannerText>
        For the optimal experience and full feature access, we recommend using our platform on a
        desktop.
      </BannerText>
    </BannerWrapper>
  );
}
